import { ContentImage } from '@aipb/gulliver/dynamic-gallery/model';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'dg-collection-cover',
  templateUrl: './collection-cover.component.html',
  styleUrls: ['./collection-cover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CollectionCoverComponent {
  @Input() defaultImage: string;
  imageContainers = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth'];

  private _images: ContentImage[] = [];

  get images() {
    return this._images;
  }

  @Input() set images(value: ContentImage[]) {
    this._images = value;
  }

  hasImage(i: number) {
    return i < this._images.length;
  }
}
